<template>
  <div id="pageNotaEntrada">
    <v-container grid-list-xl fluid>
      <v-layout row wrap justify-center>
        <v-flex lg10 sm12 xs12>
          <entrada-table></entrada-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import EntradaTable from "@/components/notaEntrada/tableNotaEntrada"
export default {
  components: {
    EntradaTable
  }
}
</script>
